import { render, staticRenderFns } from "./MedicineList.vue?vue&type=template&id=a23dc7dc&scoped=true&"
import script from "./MedicineList.vue?vue&type=script&lang=js&"
export * from "./MedicineList.vue?vue&type=script&lang=js&"
import style1 from "./MedicineList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23dc7dc",
  null
  
)

export default component.exports